// extracted by mini-css-extract-plugin
export default {"businessInfoCard":"UserCards_businessInfoCard__ZdKaF","businessNumbers":"UserCards_businessNumbers__HBbOO","logoCard":"UserCards_logoCard__TndEq"};